<template xmlns:v-on="http://www.w3.org/1999/xhtml">
	<div>
		<b-tooltip :disabled="helpState === false"
			target="choose-video-button">
			{{ $t("Tooltip.import_message") }}
		</b-tooltip>
		<b-tooltip :disabled="helpState === false"
			target="cut-video-button">
			{{ $t("Tooltip.cut_message") }}
		</b-tooltip>

		<b-modal ref="loaderModal"
			hide-footer
			static="true"
			:lazy=true
			:title="$t('Button.loader')">
			<throbber />
			<p class="my-4">{{ $t('Tooltip.message_wait') }}</p>
		</b-modal>

		<b-modal :size="'lg'"
			ref="previewModal"
			static="true"
			:lazy=true
			ok-only>
			<div class="embed-responsive embed-responsive-16by9">
				<video class="embed-responsive-item"
					:src="preview_path"
					ref="playerpreview"
					controls
					height="600"
					width="800"></video>
			</div>
		</b-modal>

		<b-modal ref="modalError"
			hide-footer
			title="Erreur">
			<lottie_error />
			<p class="my-4">{{ text_error }}</p>
		</b-modal>

		<div class="col-12 mt-4">
			<div class="row">
				<div class="col-12 col-lg-7">
					<div v-if="showCarouselVideos === false"
						class="embed-responsive embed-responsive-16by9">
						<video class="embed-responsive-item"
							:src="videoUrl"
							ref="videoplayer"
							controls></video>
					</div>
					<flickity v-if="showCarouselVideos === true && carouselVideos.length > 0"
						:options="flickityOptions">
						<div class="carousel-cell"
							v-for="(ambiance, index) in this.carouselVideos"
							:key="index">
							<video class=""
								controls>
								<source :src="ambiance.url" />
							</video>
							<div class="ambiance-checkbox">
								<label><input class="checkbox_ambiances"
									type="checkbox"
									v-model="ambiance.checked"
									:id="index"
									:value="ambiance"
									@click="setVideo(ambiance)"
									ref="checkboxAmbiances"> {{ ambiance.name.replace(/_/g, " ") }}</label>
							</div>
						</div>
					</flickity>
				</div>
				<div class="col-12 col-lg-5">
					<div class="row">
						<b-col md="auto" v-if="!hasCarouselVideos">
							<label class="btn btn-edition"
								id="choose-video-button">{{ $t("Button.import") }} <input type="file"
								id="file"
								ref="fileUpload"
								accept="video/mp4, video/quicktime"
								v-on:change="handleFileUpload()"
								hidden></label>
						</b-col>
						<b-col v-if="hasCarouselVideos"
							md="auto"
							v-bind:style="[showCarouselVideos === true ? {defaultVideosNotShow} : {defaultVideosShow}]">
							<div class="btn btn-cut"
								@click="selectDefaultVideo">{{ defaultVideosButtonText }}
							</div>
						</b-col>
						<b-col v-if="!hasCarouselVideos"
							md="auto"
							v-bind:style="[showCarouselVideos === true ? {defaultVideosShow} : {defaultVideosNotShow}]">
							<div class="btn btn-cut"
								@click="goToCut"
								id="cut-video-button">{{ $t("Button.cut") }}
							</div>
						</b-col>

					</div>
					<div class="row mt-3">
						<div class="col-12" ref="stepOfficeFields">
							<form>
								<div class="form-group"
									v-if="hasTitleField">
									<label class="sentence_label"
										for="title">{{ $t("Partners.title") }}</label>
									<span class="modificationLabel"> {{ this.modificationTitle }} </span>
									<input type="text"
										class="form-control no-border"
										id="title"
										@change="setModificationTitleLabel"
										@input="setModificationTitleLabel"
										v-model="title"
										ref="inputTitle">
								</div>
								<div class="form-group"
									v-if="hasKeywordsField">
									<label class="subtitle_label"
										for="subtitle">{{ $t("Partners.keywords") }}</label>
									<span class="modificationLabel"> {{ this.modificationKeywords }} </span>
									<input type="text"
										class="form-control no-border"
										id="subtitle"
										@change="setModificationKeywordsLabel"
										@input="setModificationKeywordsLabel"
										v-model="keywords"
										ref="inputSubtitle">
								</div>
								<div class="form-group"
									v-if="hasSecondaryTitleField">
									<label class="subtitle_label"
										for="subtitle2">{{ $t("Partners.secondary_title") }}</label>
									<span class="modificationLabel"> {{ this.modificationSecondaryTitle }} </span>
									<input type="text"
										class="form-control no-border"
										@change="setModificationSecondaryTitleLabel"
										@input="setModificationSecondaryTitleLabel"
										id="subtitle2"
										v-model="secondaryTitle" ref="inputSubtitle">
								</div>

								<ul id="partners_list">
									<li v-for="(item, id) in partners" :key="id" :class="{checked: selected_partners.includes(id)}">
										<label> <input type="radio" :value="id" v-model="selected_partners" />
											<div>
												<img :src="'/static/partners/' + item.image" :alt="item.name" />
											</div>
											<!-- <span>{{ item.name }}</span>-->
										</label>
									</li>
								</ul>
							</form>
						</div>
					</div>
				</div>
			</div>
			<div class="row">
				<div class="col-12 col-lg-12">
					<b-row>
						<b-col md="auto">
							<ValidStep :hasUploadedFile="hasUploadedFile"
								:valueTitle="title"
								:modal="$refs.loaderModal"
								:id="id"
								:completed="isCompleted"
								:valueSubtitle="secondaryTitle"
								:valueKeywords="keywords"
								:uploadVideoFile="uploadedFiles"
								:partners="selected_partners"
								:videoArray="this.carouselVideos.filter(step => step.checked === true)"
								:stepOrder="stepIndex" />
						</b-col>

						<b-col md="auto" style="padding-left: 0;">
							<div class="mt-4">
								<button
									class="btn btn-info"
									:disabled="!isCompleted || modified"
									@click="preview"
								>{{ $t("Partners.preview") }}
								</button>
							</div>
						</b-col>

						<b-col md="auto" style="padding-left: 0;">
							<div class="mt-4">
								<a href="#"
									@click.prevent="cancelUploadVideo"
									:class="[isSaved ? 'btn btn-cancel' : 'disabled btn btn-cancel']">{{ $t("Button.cancel") }}</a>
							</div>
						</b-col>
					</b-row>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import ValidStep from "../ui/buttons/ValidStepPartners";
import Flickity from "vue-flickity";
import {EventBus} from "../../event/event-bus";
import axios from "axios";
import throbber from "@/components/ui/throbber";
import lottie_error from "@/components/ui/lottie_error";

const BASE_URL = process.env.VUE_APP_BASE_URL;

export default {
	name: "StepPartners",
	components: {
		ValidStep,
		Flickity,
		throbber,
		lottie_error,
	},
	props: {
		helpState: {
			type: Boolean,
			required: true,
		},
		id: Number,
		stepName: String,
		title: String,
		secondaryTitle: String,
		keywords: String,
		isVisible: Boolean,
		isCompleted: Boolean,
		hasTitleField: Boolean,
		hasSecondaryTitleField: Boolean,
		hasKeywordsField: Boolean,
		hasMusicEnable: Boolean,
		hasCarouselVideos: Boolean,
		hasUploadedFile: Boolean,
		hasVoiceOver: Boolean,
		video: Object,
		groupId: String,
		projectId: Number,
		ambiance: Object,
		voiceOverId: Number,
		renderId: String,
		stepIndex: Number,
		created_at: String,
		updated_at: String,
	},
	data() {
		return {
			partners: {
				"test": {name: "test", image: "test.png"},
			},
			results: [],
			error: [],
			uploadedFiles: [],
			carouselVideos: [],
			hasSubtitles: false,
			isSaved: false,
			hasVideo: false,
			showCarouselVideos: false,
			flickityOptions: {
				initialIndex: 0,
				prevNextButtons: true,
				pageDots: false,
				wrapAround: false,
				draggable: false,
			},
			defaultVideosNotShow: {
				"padding": "0px",
				"cursor": "pointer",
			},
			defaultVideosShow: {
				"cursor": "pointer",
			},
			defaultVideosButtonText: "Choisir ma vidéo de fond",
			voiceOver: false,
			videoUrl: "",
			modified: false,
			ambianceId: "",
			modificationTitle: "",
			modificationKeywords: "",
			modificationSecondaryTitle: "",
			preview_path: "",
			selected_partners: [],
		};
	},
	computed: {

		voiceOverBoolean: {
			get() {
				return this.hasVoiceOver;
			},
			set(v) {
				this.hasVoiceOver = v;
			},
		},
	},
	updated() {
		EventBus.$on("hasUploadedFile", value => {
			this.hasUploadedFile = value;
		});
	},
	created() {
		let $this = this;
		EventBus.$on("setModificationTitleLabel", label => {
			$this.modificationTitle = label;
		});
		EventBus.$on("setModificationKeywordsLabel", label => {
			$this.modificationKeywords = label;
		});
		EventBus.$on("setModificationSecondaryTitleLabel", label => {
			$this.modificationSecondaryTitle = label;
		});
		EventBus.$on("setStepAmbianceComplete", id => {
			$this.getDatas(id);
		});
		EventBus.$on("isSaved", function (value) {
			if (value) {
				$this.isSaved = !value;
			}
			$this.showCarouselVideos = false;
			$this.getDatas($this.id);
		});
		EventBus.$on("videoCarouselChoose", function (value) {
			if (value) {
				$this.showCarouselVideos = !value;
				$this.getDatas($this.id);
			}
		});
		EventBus.$on("hasVideo", function (value) {
			if (value) {
				$this.hasVideo = value;
			}
		});
		EventBus.$on("hasVoiceOver", function (value) {
			if (value) {
				$this.voiceOverBoolean = value;
			}
		});
		EventBus.$on("reload_carousels", id => {
			$this.getDatas($this.id);
			// Unorthodox, but we need to refresh the step carousel and it'll call getDatas anyway
			// EventBus.$emit('setStepAmbianceComplete', $this.id);
		});
	},
	beforeRouteEnter(to, from, next) {
		axios.get(BASE_URL + "/public/api/stepPartners/" + to.params.stepId, {
			headers: {
				"Authorization": sessionStorage.getItem("auth"),
			},
		}).then(response => {
			next(vm => {
				let data = response.data.data;
				if (data.video !== undefined) {
					vm.videoUrl = data.video.url;
				}
				if (data.ambianceId !== undefined) {
					vm.videoUrl = data.ambiance.url;
				}
			});
		});
	},
	activated() {
		this.getDatas(this.id);
	},
	methods: {
		preview() {
			this.$refs.loaderModal.show();

			axios.get(BASE_URL + "/public/api/stepPartners/" + this.id + "/preview",
				{
					headers: {
						"Authorization": sessionStorage.getItem("auth"),
					},
				})
			.then(response => {
				let data = response.data;

				this.$refs.loaderModal.hide();

				this.preview_path = BASE_URL + "/public/storage/videos/generated/" + data.url + "#" + new Date().getTime();
				this.$refs.previewModal.show();
			}).catch(error => {
				this.$refs.loaderModal.hide();
				this.text_error = this.$root.$t("Errors.message_project") + error;
				this.$refs.modalError.show();
			});
		},
		getDatas(id) {
			let $this = this;
			$this.carouselVideos = [];
			axios.get(BASE_URL + "/public/api/stepPartners/" + id, {
				headers: {
					"Authorization": sessionStorage.getItem("auth"),
				},
			})
			.then(response => {
				let data = response.data.data;
				$this.isCompleted = data.isCompleted;

				if (data.title !== null) {
					$this.title = data.title;
				}
				else {
					$this.title = "";
				}

				if (data.secondaryTitle !== null) {
					$this.secondaryTitle = data.secondaryTitle;
				}
				else {
					$this.secondaryTitle = "";
				}

				if (data.keywords !== null) {
					$this.keywords = data.keywords;
				}
				else {
					$this.keywords = "";
				}

				if (data.video !== undefined) {
					$this.videoUrl = data.video.url;
					$this.hasVideo = true;
				}
				else if (data.ambiance !== undefined) {
					$this.videoUrl = data.ambiance.url;
					$this.ambianceId = data.ambiance.id;
				}
				else {
					$this.videoUrl = "";
				}

				if (data.partners !== null) {
					$this.selected_partners = JSON.parse(data.partners);
				}
				else {
					$this.selected_partners = [];
				}

				if ($this.hasCarouselVideos) {
					axios.get(BASE_URL + "/public/api/ambiances/" + id, {
						headers: {
							"Authorization": sessionStorage.getItem("auth"),
						},
					})
					.then(function (response) {
						let ambiances = response.data.data.ambiances;
						ambiances.forEach(function (element) {
							if (element.id === Number($this.ambianceId)) {
								element.checked = "checked";
							}
							$this.carouselVideos.push(element);
						});
					});
				}
			})
			.catch(error => {
				this.text_error = this.$root.$t("Errors.message_project") + error;
				this.$refs.modalError.show();
			});
		},
		setVideo(video) {
			this.carouselVideos.forEach(function (element) {
				if (video.id !== element.id) {
					element.checked = false;
				}
			});
			this.defaultVideosButtonText = "Choisir ma vidéo de fond";
		},
		cutVideo() {
			this.$router.push({
				name: "VideoEdition",
				params: {projectId: this.projectId, step_type: "App\\StepPartners", stepId: this.id},
			});
		},
		handleFileUpload() {
			let $this = this;
			if ($this.uploadedFiles.length > 1) {
				$this.uploadedFiles.splice(0, 1);
			}
			let inputFiles = $this.$refs.fileUpload.files;
			this.isSaved = true;
			let player = $this.$refs.videoplayer;
			if (inputFiles.length >= 1) {
				for (let i = 0; i <= inputFiles.length - 1; i++) {
					$this.videoUrl = URL.createObjectURL(inputFiles[i]);
					player.onloadeddata = function () {
						$this.uploadedFiles = [];
						$this.uploadedFiles.push({
							id: i,
							filename: inputFiles[i].name,
							file: inputFiles[i],
							video_duration: player.duration,
						});

						URL.revokeObjectURL(inputFiles[i]);
					};
				}
			}
		},
		cancelUploadVideo() {
			let inputFiles = this.$refs.fileUpload.files;
			if (inputFiles[0]) {
				if (inputFiles[0].name !== this.videoName) {
					let player = this.$refs.videoplayer;
					player.src = this.videoPath;
				}
			}
			this.$refs.fileUpload.value = "";
			this.isSaved = false;
		},
		selectDefaultVideo() {
			if (this.hasCarouselVideos) {
				this.showCarouselVideos = !this.showCarouselVideos;
			}
			if (this.showCarouselVideos === true) {
				this.defaultVideosButtonText = "Annuler";
			}
			else {
				this.defaultVideosButtonText = "Choisir ma vidéo de fond";
			}
		},
		goToEdition() {
			this.$router.push({
				name: "SubtitleEdition",
				params: {projectId: this.projectId, step_type: "App\\StepAmbiance", stepId: this.id},
			});
		},
		goToCut() {
			if (this.videoUrl !== undefined && this.videoUrl !== null && this.videoUrl !== "") {
				this.$router.push({
					name: "VideoEdition",
					params: {projectId: this.projectId, step_type: "App\\StepAmbiance", stepId: this.id},
				});
			}
		},
		setModificationTitleLabel() {
			this.modificationTitle = this.$root.$t("Button.editing");
		},
		setModificationKeywordsLabel() {
			this.modificationKeywords = this.$root.$t("Button.editing");
		},
		setModificationSecondaryTitleLabel() {
			this.modificationSecondaryTitle = this.$root.$t("Button.editing");
		},
	},
};
</script>

<style scoped>

.sentence_label,
.keywords_label,
.subtitle_label {
	font-size: 14px;
	color: var(--text-main);
}

.btn {
	margin-left: auto;
	border-radius: var(--small-border-radius);
}

input[type=file] {
	position: absolute;
	top: 0;
	right: 0;
	min-width: 100%;
	min-height: 100%;
	font-size: 100px;
	text-align: right;
	filter: alpha(opacity=0);
	opacity: 0;
	outline: none;
	background: white;
	cursor: inherit;
	display: block;
}

input {
	border-radius: 0;
	border-top: none;
	border-left: none;
	border-right: none;
	border-bottom: #8AA0B2 solid 1px;
}

.btn-cancel {
	background-color: var(--color-cancel);
	border-color: var(--color-cancel);
	color: var(--text-cancel);
}

.btn-edition {
	background-color: var(--color-main-action);
	border-color: var(--color-main-action);
	cursor: pointer;
	color: var(--text-main-action);
}

.btn-edition:hover {
	background-color: var(--color-main-action);
	border-color: var(--color-main-action);
	color: var(--text-main-action);
	cursor: pointer;
}

.btn-cut {
	cursor: pointer;
	background-color: var(--color-main-action);
	border-color: var(--color-main-action);
	color: var(--text-main-action);
	margin-left: 0;
}

.btn-cut:hover {
	cursor: pointer;
	background-color: var(--color-main-action);
	border-color: var(--color-main-action);
	color: var(--text-main-action);
	margin-left: 0;
}

.btn-info {
	background-color: var(--color-main-action);
	border-color: var(--color-main-action);
	color: var(--text-main-action);
}

.ambiance-checkbox {
	text-align: center;
}

input[type=checkbox] {
	transform: scale(1.5);
	margin-right: 10px;
}

.modificationLabel {
	font-size: 14px;
	color: orange;
}

.carousel-cell {
	width: 100%;
	padding-bottom: calc(56.25% + 50px);
	height: 250px;
}

.carousel-cell video {
	width: 95%;
	display: block;
	margin: 10px auto;
	border-radius: 10px;
	box-shadow: 0 0 10px #00000050;
}

.embed-responsive {
	border: none;
	border-radius: 10px;
	box-shadow: 0 0 15px #00000033;
}

#partners_list {
	list-style: none;
	display: flex;
	flex-wrap: wrap;
	justify-content: center;
	align-items: stretch;
}

#partners_list li {
	margin: 10px;
	width: 100px;
	height: 100px;
	border-radius: 10px;
	border: 1px solid grey;
	box-sizing: border-box;
}

#partners_list li.checked {
	border: 3px solid var(--color-validation);
}

#partners_list label {
	cursor: pointer;
	width: 100%;
	height: 100%;
}

#partners_list input {
	display: none;
}

#partners_list div {
	height: 100%;
	display: block;
}

#partners_list img {
	width: 90px;
	display: block;
	margin: 0 auto;
	position: relative;
	top: 50%;
	transform: translateY(-50%);
}

#partners_list span {
	display: block;
	text-align: center;
}
</style>
